import {TSKantonCode} from './enums/TSKantonCode';
import TSAbstractEntity from './TSAbstractEntity';
import TSAdresse from './TSAdresse';
import TSBenutzer from './TSBenutzer';
import {TSSerializable} from './TSSerializable';
import TSAnlaufstelle from './TSAnlaufstelle';

export default class TSInspektorat extends TSAbstractEntity implements TSSerializable<TSInspektorat> {

    private _name: string;

    private _abteilung: string | undefined;

    private _adresse: TSAdresse;

    private _active: boolean;

    private _verwalter: TSBenutzer | undefined;

    private _kanton: TSKantonCode | undefined;

    private _anlaufstellen: Array<TSAnlaufstelle>;

    private _inspektoren: Array<TSBenutzer> = [];

    public get name(): string {
        return this._name;
    }

    public set name(value: string) {
        this._name = value;
    }

    public get adresse(): TSAdresse {
        return this._adresse;
    }

    public set adresse(value: TSAdresse) {
        this._adresse = value;
    }

    public get active(): boolean {
        return this._active;
    }

    public set active(value: boolean) {
        this._active = value;
    }

    public static deserializeArray(data: any): Array<TSInspektorat> {
        let inspektoratArray: Array<TSInspektorat> = [];
        if (data && Array.isArray(data)) {
            for (let i = 0; i < data.length; i++) {
                inspektoratArray[i] = new TSInspektorat().deserialize(data[i]);
            }
        } else {
            inspektoratArray[0] = new TSInspektorat().deserialize(data);
        }
        return inspektoratArray;
    }

    public get verwalter(): TSBenutzer | undefined {
        return this._verwalter;
    }

    public set verwalter(value: TSBenutzer | undefined) {
        this._verwalter = value;
    }

    public get kanton(): TSKantonCode | undefined {
        return this._kanton;
    }

    public set kanton(value: TSKantonCode | undefined) {
        this._kanton = value;
    }

    public get abteilung(): string | undefined {
        return this._abteilung;
    }

    public set abteilung(value: string | undefined) {
        this._abteilung = value;
    }

    public get anlaufstellen(): Array<TSAnlaufstelle> {
        return this._anlaufstellen;
    }

    public set anlaufstellen(value: Array<TSAnlaufstelle>) {
        this._anlaufstellen = value;
    }

    public get inspektoren(): Array<TSBenutzer> {
        return this._inspektoren;
    }

    public set inspektoren(value: Array<TSBenutzer>) {
        this._inspektoren = value;
    }

    deserialize(restObject: any): TSInspektorat {
        super.deserialize(restObject);

        this.name = restObject.name;
        this.abteilung = restObject.abteilung;
        this.adresse = this.deserializeOrCreate(restObject.adresse, new TSAdresse());
        this.active = restObject.active;
        this.verwalter = this.deserializeOrCreate(restObject.verwalter, new TSBenutzer());

        this.kanton = restObject.kanton;
        if (restObject.anlaufstellen) {
            this.anlaufstellen = restObject.anlaufstellen.map(TSAnlaufstelle.getDeserializer);
        }

        if (restObject.inspektoren) {
            this.inspektoren = restObject.inspektoren.map(TSBenutzer.getDeserializer);
        }
        return this;
    }

    serialize(restObject: any): any {
        super.serialize(restObject);

        restObject.name = this.name;
        restObject.abteilung = this.abteilung;
        restObject.adresse = this.serializeOrInit(this.adresse, restObject.adresse);
        restObject.active = this.active;
        restObject.verwalter = this.serializeOrInit(this.verwalter, restObject.verwalter);
        restObject.kanton = this.kanton;
        restObject.anlaufstellen = this.arrayToRestObject(this.anlaufstellen);
        restObject.inspektoren = this.arrayToRestObject(this.inspektoren);

        return restObject;
    }

}



// WEBPACK FOOTER //
// ./src/app/models/TSInspektorat.ts